'use client';

import { useTranslations } from 'next-intl';
import { MouseEvent } from 'react';

import ExistingRepository from './ExistingRepository';
import NewRepository from './NewRepository';

import { Button } from 'components';
import { useGithubData } from 'providers/IntegrationsProvider/useGithubData';
import { useGithubContext } from '../_context/GithubContext';

export default function Github() {
  const t = useTranslations();
  const { data } = useGithubData();
  const { showNewForm, toggleShowNewForm } = useGithubContext();

  const handlerToggleShowNewForm = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    toggleShowNewForm();
  };

  return (
    <div className="legacy">
      {!data?.githubRepos?.length ? (
        <NewRepository />
      ) : (
        <>
          {data?.githubRepos?.map((repo) => (
            <ExistingRepository key={`repository-${repo.id}`} repository={repo} />
          ))}
          {showNewForm ? (
            <NewRepository />
          ) : (
            <div className="mt-4 flex justify-center">
              <Button size="medium" color="secondary" onClick={handlerToggleShowNewForm}>
                {t('integrations.github.add_repository')}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
